import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithBoxSignIn() {
	return <AuthShell variant="with-box"><AuthForm variant="with-box" mode="sign-in" /></AuthShell>;
}

export default AuthWithBoxSignIn;
